<template>
  <div :class="$style['pt-header']">
    <div class="header-message">
      <img :src="require('images/org-logo.png')" />
      <div>{{ title }}</div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    pageName() {
      return this.$route.name;
    },
    title() {
      let title;
      switch (this.pageName) {
        case "follower":
          title = "BCPCA-GL-054-1（V 7.1）";
          break;
        case "taskOrder":
          title = "BCPCA-GL-065（V 7.0）";
          break;
        default:
          title = "BCPCA-GL-054（V 7.0）";
          break;
      }
      return title;
    },
  },
};
</script>
<style module lang="less">
.pt-header {
  position: absolute;
  :global {
    .header-message {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
    }
  }
  img {
    width: 20px;
  }
}
</style>
